import { Button } from "../../components/Button";
import { Modal } from "../../components/Modal";
import "../../components/Form.css";

interface UnadoptServiceDialogProps {
  /** `null` closes the dialog — mirrors `DeletePlacementDialog`'s "target or null" prop
   * shape. */
  serviceName: string | null;
  isRemoving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Confirms un-adopting a service (ADR-0038 §3) — the un-adopt action IS a service
 * delete (`useDeleteService`/`ApiClient.deleteService`), just with copy that tells the
 * truth about what that call does here: the container it was bound to keeps running,
 * completely untouched, and only Comebye's record of managing it is removed.
 */
export function UnadoptServiceDialog({ serviceName, isRemoving, onCancel, onConfirm }: UnadoptServiceDialogProps) {
  return (
    <Modal open={serviceName !== null} title="Un-adopt this service" onClose={onCancel}>
      <p>
        Stop managing <strong>{serviceName ?? "this service"}</strong>? This removes the service and its placement
        from Comebye — <strong>the underlying container keeps running, untouched</strong>. Only Comebye's record of
        managing it is removed; you can adopt it again later.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isRemoving}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isRemoving}>
          {isRemoving ? "Un-adopting…" : "Un-adopt"}
        </Button>
      </div>
    </Modal>
  );
}
